import cn from "@/lib/cn";
import { ICON_THEME_COLOR, IconTheme } from "@/components/icons/theme";

export type IconCartProps = {
  theme?: IconTheme;
  style?: "filled" | "outline";
  className?: string;
  title?: string;
};

interface IconCartSvgProps {
  className?: string;
  title?: string;
}

const THEME_COLOR = ICON_THEME_COLOR;

function DefaultSvg({ className, title }: IconCartSvgProps) {
  return (
    <svg
      viewBox="0 0 16 16"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      role={title ? "img" : "presentation"}
      aria-label={title}
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.7334 1.83301C3.93337 1.83304 4.107 1.96001 4.16699 2.15332L4.51367 3.5H13.2998C14.2198 3.5 14.8729 4.35336 14.5996 5.19336L13.4863 8.58691C13.3129 9.1267 12.7864 9.5 12.1865 9.5H6.05957L5.63965 10.5137H12.3467V11.5137H4.37305C4.07989 11.5135 3.9068 11.1794 4.08008 10.9395L4.98047 9.22656L3.39355 3.02637C3.36022 2.91325 3.25355 2.83321 3.13379 2.83301H1.33301V1.83301H3.7334ZM5.54688 11.5137C6.28003 11.5138 6.87291 12.1067 6.87305 12.8398C6.87305 13.5731 6.28011 14.1669 5.54688 14.167C4.81354 14.167 4.21973 13.5732 4.21973 12.8398C4.21986 12.1066 4.81363 11.5137 5.54688 11.5137ZM10.4531 11.5137C11.1864 11.5137 11.7801 12.1066 11.7803 12.8398C11.7803 13.5732 11.1865 14.167 10.4531 14.167C9.71989 14.1669 9.12695 13.5731 9.12695 12.8398C9.12709 12.1067 9.71997 11.5138 10.4531 11.5137Z"
      />
    </svg>
  );
}

function OutlineSvg({ className, title }: IconCartSvgProps) {
  return (
    <svg
      viewBox="0 0 16 16"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      role={title ? "img" : "presentation"}
      aria-label={title}
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.7334 1.83301C3.93337 1.83304 4.107 1.96001 4.16699 2.15332L4.51367 3.5H13.2998C14.2198 3.5 14.8729 4.35336 14.5996 5.19336L13.4863 8.58691C13.3129 9.1267 12.7864 9.5 12.1865 9.5H6.05957L5.63965 10.5137H12.3398V11.5137H4.36621C4.07315 11.5133 3.9 11.1793 4.07324 10.9395L4.97363 9.22656L3.51367 3.5L3.39355 3.02637C3.36022 2.91325 3.25355 2.83321 3.13379 2.83301H1.33301V1.83301H3.7334ZM5.54688 11.5137C6.28003 11.5138 6.87291 12.1067 6.87305 12.8398C6.87305 13.5731 6.28011 14.1669 5.54688 14.167C4.81354 14.167 4.21973 13.5732 4.21973 12.8398C4.21986 12.1066 4.81363 11.5137 5.54688 11.5137ZM10.4531 11.5137C11.1864 11.5137 11.7801 12.1066 11.7803 12.8398C11.7803 13.5732 11.1865 14.167 10.4531 14.167C9.71989 14.1669 9.12695 13.5731 9.12695 12.8398C9.12709 12.1067 9.71997 11.5138 10.4531 11.5137ZM5.82715 8.5H12.1865C12.3531 8.5 12.4933 8.40669 12.54 8.27344L13.6533 4.87988H13.6602C13.6868 4.79991 13.6734 4.71979 13.6201 4.64648C13.5868 4.60648 13.4933 4.5 13.3066 4.5H4.80664L5.82715 8.5Z"
      />
    </svg>
  );
}

export default function IconCart({
  theme = "black",
  style = "filled",
  className,
  title,
}: IconCartProps) {
  const themeClassname = THEME_COLOR[theme];
  const Variant = style === "outline" ? OutlineSvg : DefaultSvg;

  return <Variant title={title} className={cn(className, themeClassname)} />;
}
